<template>
  <div>
    <h6 class="pb-3 font-weight-normal" v-if="!showView">我的悄悄话</h6>
    <!-- 悄悄话列表 -->
    <div class="qiaoqiao-list"  v-if="!showView && qqhList.data">
      <ul>
        <li v-for="(item,index) in qqhList.data" :key="index" class="d-flex justify-content-between">
          <div class="d-flex align-items-center flex-fill"  @click="showQqhView(item)"  style="min-width:0;cursor: pointer">
            <img  class="rounded-circle" style="width:48px;height:48px"
                  :src="item.userID!==loginUser.id?item.userinfo_userID.avatar:item.userinfo_touserID.avatar"
                  v-if="item.userID!==loginUser.id?item.userinfo_userID.avatar!='':item.userinfo_touserID.avatar!=''"
            />
            <div
                v-if="item.userID!==loginUser.id?item.userinfo_userID.avatar=='':item.userinfo_touserID.avatar==''"
                class="first_letter">{{item.userID===loginUser.id?item.userinfo_touserID.first_letter:item.userinfo_userID.first_letter}}</div>
            <div class="pl-2" style="min-width:0;">
              <span class="name">{{item.userinfo_userID.id!==loginUser.id?item.userinfo_userID.username:item.userinfo_touserID.username}}</span>
              <div class="wrap" v-html="item.last_messageinfo.msgbody"></div>
            </div>

          </div>
          <div class="pull-right dropdown">
            <el-dropdown trigger="click">
              <span v-html="iconmore3v">
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-popconfirm
                      placement="top-end"
                      confirm-button-text='删除'
                      cancel-button-text='取消'
                      title="确定删除这组悄悄话吗？"
                      :hide-icon="true"
                      @confirm="qqh_delete(item)"
                  >
                    <a href="javascript:void(0)" slot="reference" class="dropdown-item" style="color:gray;">删除会话</a>
                  </el-popconfirm>
                </el-dropdown-item>
                <el-dropdown-item>
                  <a class="dropdown-item"  href="javascript:void(0)" @click="blockUser(item.userinfo_userID.id!==loginUser.id?item.userinfo_userID.id:item.userinfo_touserID.id)">加入黑名单</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </li>
      </ul>
      <p class="text-center pb-5" style="cursor:pointer" v-if="!qqhList.noMore" @click="qqh_list">加载更多</p>
      <p class="text-center pb-5" v-if="qqhList.noMore">没有更多了</p>
    </div>
    <div class="row  no-gutters flex-md-row mb-4  h-md-450 position-relative"  v-if="!qqhList.data">
      <div class="col-12 pt-4 col-md-8"><img src="/img/qqh.webp" class="logo"></div>
      <div class="col-12 col-md-3 p-4 d-flex flex-column position-static">
        <div class="row featurette ">
          <div class="mt-5 col-md-12 m torder-md-2">
            <h5 class="featurette-heading">当您收到<br>悄悄话</h5>
            <p class="lead text-dark">您就可以在<br>“我的悄悄话”里<br>查看详细信息</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 悄悄话详情 -->
    <div class="qiaoqiao-view box" v-if="showView">
      <div class="row no-gutters mb-2">
        <div class="col-1 pt-2">
          <a href="#"
             class="back-to-list active"
             @click="showView=false;$router.go(-1)"
          ><left-arrow ></left-arrow>
            <!-- <span class="d-none d-sm-block">返回</span> -->
          </a>
        </div>
        <div class="col-10 pt-2 text-center">
          <b>
            与
            <a href="#" @click="$router.push('/userindex/'+user.notice.touser.id)">{{user.notice.touser.name}}</a>
            的对话
          </b>
        </div>
      </div>
      <div class="message-show" id="showbox">
        <p class="text-center pt-3" style="cursor:pointer" v-if="!qqhView.noMore" @click="qqh_view">加载更多</p>
        <p class="text-center pt-3" v-if="qqhView.noMore">没有更多了</p>
        <ul class="message-list" id="innerbox">
          <li
              v-for="(item,index) in qqhView.data"
              :key="index"
              :class="{'message-l':item.userID!==loginUser.id,'message-r':item.userID===loginUser.id,}" >
            <span class="avatar">
              <img class="rounded-circle"
                   :src="item.userinfo_userID.avatar"
                   v-if="item.userinfo_userID.avatar!=''"
              />
              <div v-if="item.userinfo_userID.avatar==''" class="first_letter">{{item.userinfo_userID.first_letter}}</div>
            </span>
            <div><span class="content" v-html="item.msgbody"></span></div>
            <span class="time">{{item.dateline*1000 | formatDate}}</span>
          </li>
        </ul>
      </div>
      <div class="write-message mb-4">
        <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="msgbody">
        </el-input>
        <!-- 输入框 -->
        <div class="text-right">
          <n-button
              type="primary"
              round
              simple
              @click.native="send()"
          >
            发送
          </n-button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { Button,} from '@/components';
import { Input } from 'element-ui';
import { LeftArrow } from "@/components/Icons";
// import Avatar from "../../blog/pages/components/Main/Avatar";
import HaiwaiIcons from '@/components/Icons/Icons';
import {formatDate} from '@/directives/formatDate.js';
export default {
  name: 'notice-qqh',
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    // DropDown,
    LeftArrow,
    // Avatar,
  },
  data(){
    return{
      loginUser:{},
      msgID:0,
      iconmore3v:HaiwaiIcons.iconmore3v,
      showView:false,
      qqhList:{lastID:0,data:[],noMore:false},
      qqhView:{lastID:0,data:[],noMore:false,id:0},
      msgbody:'',
      user:this.$store.state.user,
      report_status:false,
      replybtndisable:false,
      reportmsgbody:'',
      typeid:0
    }
  },
  created: function () {
    this.getUserInfo();
    this.init_qqh_list();
    // this.init_qqh_view();
  },

  watch:{
    'typeid':function(val){
      this.init_qqh_view();
    }
  },
  methods:{
    init_qqh_view(){
      //双循
      // this.typeid = Number(this.$route.query.typeid);
      this.qqhView.lastID=0;
      this.qqhView.data = [];
      if(this.typeid){
        this.showView = true;
        this.qqh_view().then(res=>{
          this.user.notice.touser.id = this.loginUser.id !== res.data.qqh.userinfo_userID.id ? res.data.qqh.userinfo_userID.id : res.data.qqh.userinfo_touserID.id;
          this.user.notice.touser.name = this.loginUser.id !== res.data.qqh.userinfo_userID.id ? res.data.qqh.userinfo_userID.username : res.data.qqh.userinfo_touserID.username;
          this.typeid=res.data.qqh.id;
          this.flex_bottom()
        });
      }else{
        this.showView = false;
      }
    },
    getUserInfo(){
      this.loginUser = this.$store.state.user.userinfo
    },
    async init_qqh_list(){
      let res = await this.user.qqh_list(0);
      this.qqhList.data=res.data;
      if(res.data.length==20){
        this.qqhList.noMore = false;
        this.qqhList.lastID = res.data[19].last_messageID;
      }else{
        this.qqhList.noMore = true;
      }
    },
    async qqh_list() {
      // let user = this.$store.state.user;
      let res = await this.user.qqh_list(this.qqhList.lastID);
      this.qqhList.data=this.qqhList.lastID==0?res.data:this.qqhList.data.concat(res.data);
      if(res.data.length==20){
        this.qqhList.noMore = false;
        this.qqhList.lastID = res.data[19].last_messageID;
      }else{
        this.qqhList.noMore = true;
      }
    },

    async qqh_view() {
      this.qqhView.data=this.qqhView.lastID==0?[]:this.qqhView.data;
      let res = await this.user.qqh_view(this.typeid,this.qqhView.lastID);
      // if(res.data.qqh_post.length==20){
      //   this.qqhView.noMore = false;
      //   this.qqhView.lastID = res.data.qqh_post[19].id;
      // }else{
      //   this.qqhView.noMore = true;
      // }
      this.qqhView.data=res.data.qqh_post.reverse().concat(this.qqhView.data);//对话倒序排列
      return res;
    },

    flex_bottom(){
      var ele = document.getElementById("showbox");
      if(ele.scrollHeight > ele.clientHeight) {
        ele.style.opacity = 0;
        setTimeout(()=>{
          ele.scrollTop = ele.scrollHeight;
          ele.style.opacity = 1;
        },500)
      }
    },
    showQqhView(item){
      this.user.notice.touser.id = this.loginUser.id !== item.userID ? item.userID : item.touserID;
      this.user.notice.touser.name = this.loginUser.id !== item.userID ? item.userinfo_userID.username : item.userinfo_touserID.username;
      this.typeid=item.id;
      this.$router.push({path:"/notices",query:{id:this.$route.query.id,typeid:item.id}}).catch(()=>{
        this.$message.error("数据加载失败，请返回重试！")
      })
      this.showView=true;
    },

    async send() {
      console.log(this.user.notice.touser.id)
      let res = await this.user.sendQqh(this.user.notice.touser.id,this.msgbody);
      if(res.status){
        this.qqhView.lastID = 0 ;
        this.qqh_view().then(res=>{
          this.flex_bottom()
        });
      }else{
        this.$message.error(res.error);
      }
      this.msgbody='';
    },
    // 删除悄悄话
    qqh_delete(item){
      this.$store.state.user.qqh_delete(item.id).then(res=>{
        if(res.status){
          this.qqh_list();
        }
      })
    },
    //拉黑
    blockUser(id){
      this.$store.state.user.blacklist_add(id).then(res=>{
        if(res.status){
          this.$message({message:'已加黑名单',type:'success'})
        }
      })
    },
    //举报
    report(n,data){
      let pop = 'report'+n+'-'+data.postID;
      let id = data.userinfo_userID.id!==this.loginUser.id?data.userinfo_userID.id:data.userinfo_touserID.id;
      this.$store.state.user.report_add(id,this.reportmsgbody).then(res=>{
        this.report_status = true;
        setTimeout(()=>{
          this.report_status = false;
          this.$refs[`${pop}`].doClose();
        },2000)
      })
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  }
}
</script>
<style>
/*悄悄话列表页*/
.qiaoqiao-list .dropdown-toggle::after,.qiaoqiao-view .dropdown-toggle::after {
  display:none;
}
.qiaoqiao-list .wrap {
  display: block;
  color:#999;
  padding:8px 20px 0 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.qiaoqiao-list ul {
  list-style: none;
  padding-left: 0;
}
.qiaoqiao-list li {
  padding:10px 0;
  position: relative;
  border-top: 1px solid #f0f0f0;
}
.qiaoqiao-list .avatar img{
  float: left;
  /* margin: 20px 10px 20px 5px; */
  width: 48px;
  height: 48px;
}

.qiaoqiao-view .avatar img {
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
}
.qiaoqiao-list .name {
  display: block;
  padding-top:10px;
  color: #14171a;
  font-weight: 700;
}
.qiaoqiao-list p {
  margin: 28px 0 0;
  font-size: 1rem;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.qiaoqiao-list .pull-right {
  margin: 20px 10px 0 0;
  font-size: 13px;
  float: right !important;
}
.qiaoqiao-list .pull-right div {
  display: inline;
}
.qiaoqiao-list .pull-right .time {
  font-size: small;
  color: #9a9a9a;
  font-weight: 500;
  margin-right: 10px;
}
/*悄悄话详情页*/
.qiaoqiao-view .message-show{
  height: calc(100vh - 37vh);
  overflow-y:scroll ;
}
.qiaoqiao-view .message-show::-webkit-scrollbar {/*滚动条整体样式*/
  width:4px;
}
.qiaoqiao-view .message-show::-webkit-scrollbar-thumb { /* 拖动条 */
  background-color: rgba(0,0,0,.15);
  border-radius: 2px;
}
.qiaoqiao-view .first_letter,.qiaoqiao-list .first_letter{
  color:#14171a;
  border-radius: 50%;
  height:48px;
  width: 48px;
  margin: 0 !important;
  text-align: center;
  line-height: 48px;
  display: block;
  background-color: aliceblue;
}
.qiaoqiao-view .back-to-list {
  font-size: 14px;
  color: #969696;
}
.qiaoqiao-view .message-l div .content {
  min-height: 39px;
  background-color: #eee;
  border-color: #d9d9d9;
  border-radius: 0 4px 4px 4px;
  position: relative;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid;
  word-break: break-word !important;
  line-height: 1.5;
  display: table-cell;
}
.qiaoqiao-view .push-top b {
  display: inline-block;
  padding: 0 140px 0 160px;
  font-size: 14px;
}

.qiaoqiao-view .message-show li div {
  position: relative;
  display: block;
  margin: 4px 56px 0;
  min-height: 39px;
}
.qiaoqiao-view .message-show li div .content {
  position: relative;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid;
  word-break: break-word !important;
  word-break: break-all;
  line-height: 1.5;
  display: table-cell;
}
.qiaoqiao-view .message-show .message-l div .content {
  min-height: 39px;
  background-color: #eee;
  border-color: #d9d9d9;
  border-radius: 4px;
}
.qiaoqiao-view .message-show .message-l div:before {
  left: -9px;
  border-left: 9px solid transparent;
  border-top: 16px solid #bad0e9;
}
.qiaoqiao-view .message-show .message-list {
  margin: 0;
  padding: 10px 0 0 0;
}
.qiaoqiao-view .message-show li {
  margin-bottom: 15px;
  overflow: hidden;
}
.qiaoqiao-view .message-show .avatar {
  float: left;
  width: 40px;
  height: 40px;
}
.qiaoqiao-view .message-show .message-r .time {
  float: right;
  margin-right: 56px;
}
.qiaoqiao-view .message-show .message-l .time {
  margin-left: 56px;
}
.qiaoqiao-view .message-show .time {
  margin-top: 2px;
  font-size: 12px;
  color: #9a9a9a;
}

.qiaoqiao-view .message-show .message-r div .content {
  float: right;
  min-height: 39px;
  background-color: #e7f1fc;
  border-color: #3ab6eb41;
  border-radius: 4px;
}
.qiaoqiao-view .message-show .message-r .avatar {
  float: right;
}

.haiwaiicon svg{
  width:20px;
  height:20px;
  fill:#14171A;
}
.dropdown li{
  border: 0;
}
</style>